<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerExternalFormats">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="editPanel" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { ExternalFormatService } from "../../../services/ExternalFormatService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "ExternalFormatPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      externalFormat: null,
      externalFormatService: new ExternalFormatService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime"
    }),
    headerExternalFormats() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.externalFormat) {
        return {
          title: this.externalFormat.value,
          id: this.ids[0],
          status: this.getStatus(this.externalFormat.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.externalFormat) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.externalFormat.code,
            },
          ],
          [
            {
              title: this.$t("externalFormatValue"),
              text: this.externalFormat.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.externalFormat) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.externalFormat.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.externalFormat.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.externalFormat.createdAt) + ' ' + getAMorPM(this.externalFormat.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.externalFormat.lastUpdated) + ' ' + getAMorPM(this.externalFormat.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getExternalFormat();
      } catch (e) {
        this.hasError = true;
      }
    },
    getExternalFormat() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.externalFormatService.get(this.ids[0]).then((res) => {
          this.externalFormat = res.data;
          this.loading = false;
        });
      }
      this.externalFormat = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.externalFormat);
    },
    deletePanel() {
      this.$emit("delete", this.externalFormat);
    },
    showHistoryPanel() {
      this.$emit("history", this.externalFormat);
    },
  },
};
</script>

<style scoped></style>
